// extracted by mini-css-extract-plugin
module.exports = {"categoriza":"dp-nD3QtaYF","container":"dp-5pm91tV0","container__popover":"dp-sK8PP530","container__filter":"dp-YHXIrivX","container__item":"dp-TE0VKYi4","active":"dp-Ob5lqzp0"};